import type { HdcReport } from "../../../../../ExperianPrivateResponse.types";
import {
  InquiryRowVM,
  SavingsRowVM,
  mapInquiries,
  mapSavings,
} from "../mappers";
import { C, tabular } from "../theme";
import { Card } from "../shared/Card";
import { Column, DataTable } from "../shared/DataTable";

const savingsColumns: Column<SavingsRowVM>[] = [
  { key: "entity", header: "Entidad", align: "l", strong: true, render: (s) => s.entity },
  { key: "type", header: "Tipo", render: (s) => s.type },
  { key: "account", header: "Cuenta", render: (s) => s.account, cellStyle: () => tabular },
  { key: "opened", header: "Apertura", render: (s) => s.opened },
  {
    key: "status",
    header: "Estado",
    render: (s) => s.status,
    cellStyle: () => ({ color: C.ok, fontWeight: 600 }),
  },
  { key: "city", header: "Ciudad", render: (s) => s.city },
];

const inquiryColumns: Column<InquiryRowVM>[] = [
  { key: "date", header: "Fecha", render: (q) => q.date, cellStyle: () => tabular },
  { key: "entity", header: "Entidad", align: "l", strong: true, render: (q) => q.entity },
  { key: "product", header: "Producto", render: (q) => q.product },
  { key: "city", header: "Ciudad", render: (q) => q.city },
  { key: "reason", header: "Motivo", render: (q) => q.reason },
];

const Empty = ({ text }: { text: string }) => (
  <p style={{ margin: 0, padding: "0 20px 10px", fontSize: 13, color: C.muted }}>
    {text}
  </p>
);

export const CuentasConsultasTab = ({ report }: { report: HdcReport }) => {
  const savings = mapSavings(report);
  const inquiries = mapInquiries(report);
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(min(420px, 100%), 1fr))",
        gap: 20,
      }}
    >
      <Card flush title="Cuentas de ahorro y corriente">
        {savings.length ? (
          <DataTable
            caption="Cuentas de ahorro y corriente"
            columns={savingsColumns}
            rows={savings}
          />
        ) : (
          <Empty text="Sin cuentas reportadas." />
        )}
      </Card>
      <Card flush title="Huellas de consulta">
        {inquiries.length ? (
          <DataTable
            caption="Huellas de consulta"
            columns={inquiryColumns}
            rows={inquiries}
          />
        ) : (
          <Empty text="Sin consultas reportadas." />
        )}
      </Card>
    </div>
  );
};
